"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _end_of_day = _interopRequireDefault(require("date-fns/end_of_day"));

var _start_of_day = _interopRequireDefault(require("date-fns/start_of_day"));

var _default = function _default(date, way) {
  if (way === void 0) {
    way = 'left';
  }

  return way === 'right' ? (0, _end_of_day["default"])(date) : (0, _start_of_day["default"])(date);
};

exports["default"] = _default;